import { Loading, useSnackbar } from '@rrexpress/core';

import { BaseForm } from '@/components/form/form';
import FormField from '@/components/form/form-field';
import { useModal } from '@/hooks/useModal';
import useUser from '@/modules/user/application/user';

type FormPersonalDataProps = {
  data: IUser;
  onSuccess: () => void;
};

const FormPersonalData = ({ data, onSuccess }: FormPersonalDataProps) => {
  const { close } = useModal();
  const { updateUser, loadingUpdate } = useUser();
  const { show } = useSnackbar();

  async function handleUpdateUser(value: IUser) {
    const {
      updated_user_id: uui,
      created_user_id: cui,
      updated_time_utc: utu,
      created_time_utc: ctu,
      ...dataDefault
    } = data;

    try {
      await updateUser(data.user_id, {
        ...dataDefault,
        ...value,
        role_id: value.role_id || data.role_id || '7089fe8a-1f3f-4966-8e2b-208a6a75a3b1', // hardcode owner
        actor_user_id: data.user_id,
      });

      show('Berhasil mengubah data profile', 'success');
      close();
      onSuccess();
    } catch (error) {
      show('Gagal mengubah data profile', 'error');
    }
  }

  return (
    loadingUpdate ? (
      <Loading
        variant="circular"
        size={40}
        speed={0.6}
        indicatorCap="round"
      />
    ) : (
      <BaseForm
        onFinish={handleUpdateUser}
        onCancel={() => close()}
        initialValue={{
          first_name: data.first_name,
          last_name: data.last_name,
          phone_number: data.phone_number,
        }}
      >
        <div className="mb-3">
          <FormField
            label="Nama Depan"
            component="form"
            name="first_name"
            componentProps={{
              required: true,
              label: 'Nama Depan',
            }}
          />
        </div>
        <div className="mb-3">
          <FormField
            label="Nama Belakang"
            component="form"
            name="last_name"
            componentProps={{
              required: true,
              label: 'Nama Belakang',
            }}
          />
        </div>
        <div className="mb-3">
          <FormField
            label="No. Telp"
            component="form"
            name="phone_number"
            componentProps={{
              required: true,
              label: 'No Telp.',
            }}
          />
        </div>
      </BaseForm>
    )
  );
};

export default FormPersonalData;
